import React from 'react';

function Sort() {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z" />
    </svg>
  );
}

export default Sort;



// WEBPACK FOOTER //
// ./src/common/icons/Sort.js